module.exports = __webpack_public_path__ + "img/google_play_badge_en.9bcae222.png";